import {
  IconChipSmall,
  IconChipMedium,
  IconChipLarge,
  Flex,
} from "./StyledIcon.styles";
import { MediumText } from "../../styles/Typography";

interface StylediconProps {
  icon: React.ReactNode;
  text?: any;
}

export const StyledIconSmall: React.FC<StylediconProps> = ({ icon }) => {
  return <IconChipSmall>{icon}</IconChipSmall>;
};

export const StyledIconMedium: React.FC<StylediconProps> = ({ icon }) => {
  return <IconChipMedium>{icon}</IconChipMedium>;
};

export const StyledIconLarge: React.FC<StylediconProps> = ({ icon }) => {
  return <IconChipLarge>{icon}</IconChipLarge>;
};

export const StyledIconLine: React.FC<StylediconProps> = ({ icon, text }) => {
  return (
    <Flex>
      <IconChipMedium>{icon}</IconChipMedium>
      {typeof text === "string" ? <MediumText>{text}</MediumText> : text}
    </Flex>
  );
};
